import FormV2 from './FormV2.vue';

export default function install(Vue) {
  Vue.component(FormV2.name, FormV2);
}
